"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDesktop = void 0;
var React = require("react");
var format_1 = require("@/utils/format");
var classNames = require("classnames");
var StampdutyHelper_1 = require("@/pages/stampduty/components/StampdutyHelper");
exports.renderDesktop = function (props) {
    var renderTableHeads = function (props) {
        var renderTableHead = function (name, i, style) {
            if (style === void 0) { style = {}; }
            return (React.createElement("th", { key: i, style: style }, format_1.default.stripTag(name)));
        };
        var sl = props.contentSection.stampDutyList;
        return [
            renderTableHead('', 1),
            renderTableHead(sl.regularStampDuty.name, 2, { width: '32%' }),
            renderTableHead(sl.specialStampDuty.name, 3),
            renderTableHead(sl.buyersStampDuty.name, 4),
            renderTableHead(sl.adValoremStampDuty.name, 5),
        ];
    };
    var renderTableRows = function (props) {
        var renderRow = function (value, i) {
            if (StampdutyHelper_1.stampDutyHelper.isString(value)) {
                return (React.createElement("td", { key: i }, format_1.default.stripTag(value)));
            }
            if (StampdutyHelper_1.stampDutyHelper.isStringArray(value)) {
                return (React.createElement("td", { key: i }, value.map(function (it, i) { return (React.createElement("p", { key: i }, format_1.default.stripTag(it))); })));
            }
            if (StampdutyHelper_1.stampDutyHelper.isSubitem(value)) {
                var RF_1 = React.Fragment;
                var renderSub_1 = function (sub) { return (React.createElement(React.Fragment, null,
                    format_1.default.stripTag(sub.item),
                    React.createElement("br", null),
                    sub.subItems.map(function (it, i) { return (React.createElement(RF_1, { key: i },
                        format_1.default.stripTag(it),
                        React.createElement("br", null))); }))); };
                return (React.createElement("td", { key: i }, value.map(function (it, i) { return (React.createElement("p", { key: i }, renderSub_1(it))); })));
            }
            if (StampdutyHelper_1.stampDutyHelper.isAmountValue(value)) {
                var renderTable = function (rows) {
                    var renderRow = function (row, i) { return (React.createElement("tr", { key: i },
                        React.createElement("td", null, format_1.default.stripTag(row.range)),
                        React.createElement("td", null, format_1.default.stripTag(row.amount)))); };
                    var classname = classNames([
                        'c-stampduty__table', 'c-stampduty__table--open', 'c-stampduty__table--nocenter',
                    ]);
                    return (React.createElement("div", { className: "c-stampduty__outdent" },
                        React.createElement("table", { className: classname },
                            React.createElement("tbody", null, rows.map(function (it, i) { return renderRow(it, i); })))));
                };
                return (React.createElement("td", { key: i },
                    React.createElement("p", { className: "l-pad" }, format_1.default.stripTag(value.purchaseAmountOrValue)),
                    renderTable(value.items)));
            }
        };
        var renderRows = function (rows, i) {
            return (React.createElement("tr", { key: i }, rows.map(function (it, i) { return renderRow(it, i); })));
        };
        var c = props.contentSection;
        var rows = [
            renderRows([
                c.translate.transactionsAffected,
                c.stampDutyList.regularStampDuty.transactionsAffected,
                c.stampDutyList.specialStampDuty.transactionsAffected,
                c.stampDutyList.buyersStampDuty.transactionsAffected,
                c.stampDutyList.adValoremStampDuty.transactionsAffected,
            ], 1),
            renderRows([
                c.translate.responsibleForPayment,
                c.stampDutyList.regularStampDuty.responsibleForPayment,
                c.stampDutyList.specialStampDuty.responsibleForPayment,
                c.stampDutyList.buyersStampDuty.responsibleForPayment,
                c.stampDutyList.adValoremStampDuty.responsibleForPayment,
            ], 2),
            renderRows([
                c.translate.effectiveDates,
                c.stampDutyList.regularStampDuty.effectiveDates,
                c.stampDutyList.specialStampDuty.effectiveDates,
                c.stampDutyList.buyersStampDuty.effectiveDates,
                c.stampDutyList.adValoremStampDuty.effectiveDates,
            ], 3),
            renderRows([
                c.translate.paymentAmount,
                c.stampDutyList.regularStampDuty.paymentAmount,
                c.stampDutyList.specialStampDuty.paymentAmount,
                c.stampDutyList.buyersStampDuty.paymentAmount,
                c.stampDutyList.adValoremStampDuty.paymentAmount,
            ], 4),
            renderRows([
                c.translate.exemptions,
                c.stampDutyList.regularStampDuty.exemptions,
                c.stampDutyList.specialStampDuty.exemptions,
                c.stampDutyList.buyersStampDuty.exemptions,
                c.stampDutyList.adValoremStampDuty.exemptions,
            ], 5),
        ];
        return rows;
    };
    return (React.createElement("div", { className: "l-pad l-pad--4 c-stampduty__relative" },
        React.createElement("div", { className: "c-stampduty__watermark" }, "OKAY.COM"),
        React.createElement("table", { className: "c-stampduty__table c-stampduty__table--center" },
            React.createElement("thead", null,
                React.createElement("tr", null, renderTableHeads(props))),
            React.createElement("tbody", null, renderTableRows(props)))));
};
